import { Link } from "react-router-dom";
import { EmailSignInForm } from "../components/EmailSignInForm.js";
import "./Login.css";

export function Login() {
  return (
    <main className="login">
      <div className="login__card">
        <Link to="/" className="brand brand--ink login__brand">
          <img src="/tatu.svg" alt="" aria-hidden="true" width={32} height={32} />
          Ondetatu
        </Link>
        <h1 className="login__title">Welcome back</h1>
        <p className="login__sub">
          Ondetatu is invite only. Enter your email and we'll send you a sign-in link — no password
          needed.
        </p>

        <EmailSignInForm cta="Email me a sign-in link" />

        <p className="login__foot">
          No invite yet?{" "}
          <a href="mailto:invites@ondetatu.com?subject=Ondetatu%20invite">Request one</a>.
        </p>
      </div>
    </main>
  );
}
